/*
 * 百舸云平台权限配置 - 企业客户权限
 *
 * name                     应用名称
 * version                  应用版本  1.0.0 开始
 * menus                    全部菜单  Array
 *   name                   菜单标识
 *   title                  菜单名称
 *   views                  二级菜单
 *     pc                   pc端  Array
 *       name               菜单标识
 *       title              菜单名称
 *       haveMenuSubpage    一级菜单有子页面
 *       auth               功能权限
 *         name             权限名称
 *         permission       权限值  菜单标识_菜单标识_功能
 *         haveSubpage      二级菜单有子页面
 *         pages            子页面标识  Array
 *
 *     mobile               移动端  Array
 */

export default {
  name: 'BaiGeYun',
  version: '1.0.0',
  menus: [
    {
      name: 'overview',
      title: '概况总览',
      views: {
        pc: [
          {
            name: 'overview',
            title: '概况总览',
            auth: [
              {
                name: '查看',
                permission: 'overview_overview_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'organizationManage',
      title: '组织机构',
      views: {
        pc: [
          {
            name: 'companyManage',
            title: '企业管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_companyManage_view'
              },
              {
                name: '修改',
                permission: 'organizationManage_companyManage_modify'
              }
            ]
          },
          {
            name: 'roleManage',
            title: '角色管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_roleManage_view'
              },
              {
                name: '新增 / 编辑',
                permission: 'organizationManage_roleManage_addAndModify',
                haveSubpage: true,
                pages: ['addOrModifyRole']
              },
              {
                name: '推送设置',
                permission: 'organizationManage_roleManage_pushSet'
              },
              {
                name: '启用 / 禁用',
                permission: 'organizationManage_roleManage_onAndOff'
              },
              {
                name: '删除',
                permission: 'organizationManage_roleManage_delete'
              }
            ]
          },
          {
            name: 'userManage',
            title: '用户管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_userManage_view'
              },
              {
                name: '新增部门 / 编辑部门',
                permission: 'organizationManage_userManage_addAndModifyOrganization'
              },
              {
                name: '删除部门',
                permission: 'organizationManage_userManage_deleteOrganization'
              },
              {
                name: '用户账号管理',
                permission: 'organizationManage_userManage_userAccountManage'
              },
              {
                name: '授权设备 / 取消授权',
                permission: 'organizationManage_userManage_onAndOffDevice'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'gatewayManage',
      title: '网关管理',
      views: {
        pc: [
          {
            name: 'gatewayManage',
            title: '网关管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'gatewayManage_gatewayManage_view',
                haveSubpage: true,
                pages: ['gatewayDetail']
              },
              {
                name: '网关入库',
                permission: 'gatewayManage_gatewayManage_entry'
              },
              // {
              //   name: 'HiVPN',
              //   permission: 'gatewayManage_gatewayManage_HiVPN'
              // },
              // {
              //   name: 'GRMP',
              //   permission: 'gatewayManage_gatewayManage_GRMP'
              // },
              {
                name: '删除',
                permission: 'gatewayManage_gatewayManage_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'equipmentCenter',
      title: '设备中心',
      views: {
        pc: [
          {
            name: 'productManage',
            title: '产品管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_productManage_view',
                haveSubpage: true,
                pages: ['productDetail']
              },
              {
                name: '新增',
                permission: 'equipmentCenter_productManage_add'
              },
              {
                name: '类别管理',
                permission: 'equipmentCenter_productManage_category'
              },
              {
                name: '管理设备',
                permission: 'equipmentCenter_productManage_manageDevice'
              },
              // {
              //   name: '同步信息',
              //   permission: 'equipmentCenter_productManage_syncInfo'
              // },
              {
                name: '复制',
                permission: 'equipmentCenter_productManage_copy'
              },
              {
                name: '删除',
                permission: 'equipmentCenter_productManage_delete'
              }
            ]
          },
          {
            name: 'deviceManage',
            title: '设备管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_deviceManage_view',
                haveSubpage: true,
                pages: ['deviceDetail']
              },
              {
                name: '新增',
                permission: 'equipmentCenter_deviceManage_add'
              },
              // {
              //   name: '同步信息',
              //   permission: 'equipmentCenter_deviceManage_syncInfo'
              // },
              // {
              //   name: '启用 / 禁用',
              //   permission: 'equipmentCenter_deviceManage_use'
              // },
              // {
              //   name: '召回',
              //   permission: 'equipmentCenter_deviceManage_callback'
              // },
              // {
              //   name: '分享',
              //   permission: 'equipmentCenter_deviceManage_share'
              // },
              {
                name: '复制',
                permission: 'equipmentCenter_deviceManage_copy'
              },
              // {
              //   name: '地址映射',
              //   permission: 'equipmentCenter_deviceManage_address'
              // },
              {
                name: '删除',
                permission: 'equipmentCenter_deviceManage_delete'
              },
              {
                name: '编辑',
                permission: 'equipmentCenter_deviceManage_edit'
              }
            ]
          },
          {
            name: 'productLineManage',
            title: '产线管理',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_productLineManage_view',
                haveSubpage: true,
                pages: ['productLineDetail']
              },
              {
                name: '新增',
                permission: 'equipmentCenter_productLineManage_add'
              },
              {
                name: '编辑',
                permission: 'equipmentCenter_productLineManage_edit'
              },
              {
                name: '删除',
                permission: 'equipmentCenter_productLineManage_delete'
              },
              {
                name: '分享',
                permission: 'equipmentCenter_productLineManage_share'
              },
              {
                name: '召回',
                permission: 'equipmentCenter_productLineManage_callback'
              }
            ]
          },
          {
            name: 'deviceGroup',
            title: '设备分组',
            auth: [
              {
                name: '查看',
                permission: 'equipmentCenter_deviceGroup_view'
              },
              {
                name: '自定义分组管理',
                permission: 'equipmentCenter_deviceGroup_customerGroup'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'scadaManage',
      title: '组态管理',
      views: {
        pc: [
          {
            name: 'productScada',
            title: '产品组态',
            auth: [
              {
                name: '查看',
                permission: 'scadaManage_productScada_view'
              },
              {
                name: '设计',
                permission: 'scadaManage_productScada_design'
              },
              {
                name: '新增',
                permission: 'scadaManage_productScada_add'
              },
              {
                name: '编辑',
                permission: 'scadaManage_productScada_edit'
              },
              {
                name: '复制',
                permission: 'scadaManage_productScada_copy'
              },
              {
                name: '删除',
                permission: 'scadaManage_productScada_delete'
              }
            ]
          },
          {
            name: 'productLineScada',
            title: '产线组态',
            auth: [
              {
                name: '查看',
                permission: 'scadaManage_productLineScada_view'
              },
              {
                name: '设计',
                permission: 'scadaManage_productLineScada_design'
              },
              {
                name: '新增',
                permission: 'scadaManage_productLineScada_add'
              },
              {
                name: '编辑',
                permission: 'scadaManage_productLineScada_edit'
              },
              {
                name: '复制',
                permission: 'scadaManage_productLineScada_copy'
              },
              {
                name: '删除',
                permission: 'scadaManage_productLineScada_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    // {
    //   name: 'dataLargeScreen',
    //   title: '数据大屏',
    //   views: {
    //     pc: [
    //       {
    //         name: 'my',
    //         title: '我的大屏',
    //         auth: [
    //           {
    //             name: '查看',
    //             permission: 'dataLargeScreen_my_view'
    //           },
    //           {
    //             name: '操作',
    //             permission: 'dataLargeScreen_my_operate'
    //           }
    //         ]
    //       },
    //       {
    //         name: 'template',
    //         title: '模板中心',
    //         auth: [
    //           {
    //             name: '查看',
    //             permission: 'dataLargeScreen_template_view'
    //           }
    //         ]
    //       },
    //       {
    //         name: 'dataSource',
    //         title: '数据源',
    //         auth: [
    //           {
    //             name: '查看',
    //             permission: 'dataLargeScreen_dataSource_view'
    //           }
    //         ]
    //       }
    //     ],
    //     mobile: []
    //   }
    // },
    {
      name: 'smsManageForCustomer',
      title: '短信管理',
      views: {
        pc: [
          {
            name: 'smsManageForCustomer',
            title: '短信管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'smsManageForCustomer_smsManageForCustomer_view'
              },
              {
                name: '预警设置',
                permission: 'smsManageForCustomer_smsManageForCustomer_warnSet'
              },
              {
                name: '重新发送',
                permission: 'smsManageForCustomer_smsManageForCustomer_resend'
              },
              {
                name: '购买套餐',
                permission: 'smsManageForCustomer_smsManageForCustomer_buyPackage'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'iotCardManageForCustomer',
      title: '物联卡管理',
      views: {
        pc: [
          {
            name: 'iotCardManageForCustomer',
            title: '物联卡管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_view'
              },
              {
                name: '续费套餐',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_rebuy'
              },
              {
                name: '预警设置',
                permission: 'iotCardManageForCustomer_iotCardManageForCustomer_warnSet'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'sendMessage',
      title: '发送消息',
      views: {
        pc: [
          {
            name: 'sendMessage',
            title: '发送消息',
            auth: [
              {
                name: '查看',
                permission: 'sendMessage_sendMessage_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'systemManageForCustomer',
      title: '系统日志',
      views: {
        pc: [
          {
            name: 'systemManageForCustomer',
            title: '系统日志',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'systemManageForCustomer_systemManageForCustomer_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'monitorMaintenance',
      title: '监控运维',
      views: {
        pc: [
          {
            name: 'mapMonitor',
            title: '地图监控',
            auth: [
              {
                name: '查看',
                permission: 'monitorMaintenance_mapMonitor_view'
              }
            ]
          },
          {
            name: 'deviceMonitor',
            title: '设备监控',
            auth: [
              {
                name: '查看',
                permission: 'monitorMaintenance_deviceMonitor_view'
              }
            ]
          },
          {
            name: 'productLineMonitor',
            title: '产线监控',
            auth: [
              {
                name: '查看',
                permission: 'monitorMaintenance_productLineMonitor_view'
              }
            ]
          },
          {
            name: 'staticReport',
            title: '统计报表',
            auth: [
              {
                name: '系统报表',
                permission: 'monitorMaintenance_staticReport_systemReport'
              },
              {
                name: '设备报表',
                permission: 'monitorMaintenance_staticReport_deviceReport'
              },
              {
                name: '故障报表',
                permission: 'monitorMaintenance_staticReport_faultReport'
              },
              {
                name: '历史数据',
                permission: 'monitorMaintenance_staticReport_historyData'
              }
            ]
          }
        ],
        mobile: []
      }
    }
  ]
};
